import {
  Accordion,
  Alert,
  Button,
  Card,
  Checkbox,
  FileInput,
  Label,
  Table,
} from "flowbite-react";
import { useEffect, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { IoDownload } from "react-icons/io5";
import Papa from "papaparse";
import { formatToReal } from "../../utils/utils";

const BlacklistImportForm = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorQuery, setErrorQuery] = useState(false);
  const [blaclistData, setBlacklistData] = useState([]);

  const goToStep = (step) => {
    setActiveStep(step);
  };

  const keyMapping = {
    Documento: "document",
    "Tipo de apontamento": "type",
    Quantidade: "quantity",
    Valor: "value",
    Data: "date",
    Logradouro: "address",
    Numero: "addressNumber",
    Complemento: "addressComplement",
    Cidade: "addressCity",
    Uf: "addressUF",
    Cep: "cep",
  };

  const expectedHeaders = Object.keys(keyMapping);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (!file) {
      alert("Por favor, selecione um arquivo CSV.");
      return;
    }

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        const csvHeaders = result.meta.fields || [];

        const missingHeaders = expectedHeaders.filter(
          (header) => !csvHeaders.includes(header)
        );

        if (missingHeaders.length > 0) {
          alert(
            `Erro: O arquivo CSV está no formato incorreto. Faltam as colunas: ${missingHeaders.join(
              ", "
            )}`
          );
          setBlacklistData([]);
          return;
        }

        const parsedData = result.data.map((row) => {
          let transformedRow = {};
          Object.keys(row).forEach((originalKey) => {
            const newKey = keyMapping[originalKey] || originalKey;
            transformedRow[newKey] = row[originalKey];
          });
          return transformedRow;
        });

        setBlacklistData(parsedData);
      },
      error: (error) => {
        alert(`Erro ao processar o CSV: ${error.message}`);
        setBlacklistData([]);
      },
    });
  };

  return (
    <Card>
      {activeStep === 1 && (
        <form>
          <h2 className="title-syncx mb-6">Importar dados em massa</h2>
          <div className="flex gap-4 flex-col">
            <a
              href="/assets/blacklist/Blacklist_modelo.csv"
              download
              className="w-fit bg-gray-500 text-white rounded-md px-4 py-2 text-sm"
            >
              <div className="flex gap-2 items-center">
                <IoDownload />
                <div>Baixar modelo de CSV</div>
              </div>
            </a>
            <div>
              <div>
                <Label
                  htmlFor="file-upload-helper-text"
                  value="Fazer upload do arquivo"
                />
              </div>
              <FileInput
                id="file-upload-helper-text"
                helperText="Formato esperado: CSV"
                onChange={handleFileUpload}
              />
            </div>

            {blaclistData?.length > 0 && (
              <>
                <div className="text-sm">
                  Quantidade total de registros para importação:{" "}
                  {blaclistData?.length}
                </div>
                <Table striped>
                  <Table.Head>
                    <Table.HeadCell className="bg-gray-300">
                      Documento
                    </Table.HeadCell>
                    <Table.HeadCell className="bg-gray-300 text-center">
                      Tipo
                    </Table.HeadCell>
                    <Table.HeadCell className="text-center bg-gray-300">
                      Data
                    </Table.HeadCell>
                    <Table.HeadCell className="text-center bg-gray-300">
                      Valor
                    </Table.HeadCell>
                    <Table.HeadCell className="bg-gray-300">
                      Endereço
                    </Table.HeadCell>
                  </Table.Head>

                  <Table.Body className="divide-y">
                    <>
                      {blaclistData.map((blacklist, index) => (
                        <Table.Row
                          key={index}
                          className="bg-white dark:border-gray-700 dark:bg-gray-800"
                        >
                          <Table.Cell className="font-medium text-gray-900 dark:text-white py-2">
                            {blacklist.document}
                          </Table.Cell>
                          <Table.Cell className="font-medium text-gray-900 dark:text-white py-2 text-center capitalize">
                            {blacklist?.type?.toLowerCase()}
                          </Table.Cell>
                          <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                            {blacklist.date || "-"}
                          </Table.Cell>
                          <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                            {formatToReal(blacklist.value)}
                          </Table.Cell>
                          <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                            <td className="p-1 text-xs">
                              {blacklist.address
                                ? `${blacklist.address}, ${blacklist.addressNumber} |
                                ${blacklist.addressNeighborhood} - ${blacklist.addressCity}, 
                                ${blacklist.cep}`
                                : "-"}
                            </td>
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </>
                  </Table.Body>
                </Table>
              </>
            )}

            <Button
              className="shadow md:max-w-60 mx-auto px-10 whitespace-nowrap"
              type="submit"
            >
              Iniciar importação
            </Button>
          </div>
        </form>
      )}

      {activeStep === 3 && (
        <div className="flex flex-col h-40 justify-center items-center font-semibold text-lg gap-2">
          <FaCheckCircle fontSize={26} style={{ color: "var(--primary)" }} />
          <div>Registro cadastrado com sucesso!</div>
          <div className="flex flex-col md:flex-row justify-center gap-4 mt-2">
            <Button
              onClick={() => {
                goToStep(1);
              }}
              className="w-full md:w-fit bg-gray-600 shadow whitespace-nowrap primary"
            >
              Novo cadastro
            </Button>
            <Button
              className="w-full bg-gray-500 shadow px-8"
              onClick={() => navigate("/queries/blacklist")}
            >
              Voltar
            </Button>
          </div>
        </div>
      )}
    </Card>
  );
};

export default BlacklistImportForm;
